import React from 'react';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';

// Create and export the ref
export const toastRef = React.createRef<ToastComponent>();

export default function GlobalToast() {
  return (
    <ToastComponent
      ref={toastRef}
      position={{ X: 'Right', Y: 'Top' }}
      showProgressBar={true}
      timeOut={3000}
      showCloseButton={true}
    />
  );
}
